import { ErrorCode } from '@/errors/codes'

/**
 * Maps BFF `error_code` on 401 responses to a dedicated error route.
 * Backend codes use the `BACKEND_<digits>` prefix; keep cases in sync with the API StrEnum.
 */
export function dedicatedErrorCodeFromBackend401Payload(errorCode: unknown): ErrorCode | null {
  if (typeof errorCode !== 'string' || errorCode.length === 0) {
    return null
  }
  switch (errorCode) {
    case ErrorCode.AuthCodeTokenExchangeFailed:
      return ErrorCode.AuthCodeTokenExchangeFailed
    case ErrorCode.KeycloakTokenSignatureInvalid:
      return ErrorCode.KeycloakTokenSignatureInvalid
    case ErrorCode.KeycloakTokenExpirationInvalid:
      return ErrorCode.KeycloakTokenExpirationInvalid
    case ErrorCode.KeycloakJwtDecodeFailed:
      return ErrorCode.KeycloakJwtDecodeFailed
    case ErrorCode.UnknownErrorDuringJwtDecoding:
      return ErrorCode.UnknownErrorDuringJwtDecoding
    case ErrorCode.KeycloakIdTokenNonceViolation:
      return ErrorCode.KeycloakIdTokenNonceViolation
    case ErrorCode.KeycloakIntrospectionFailed:
      return ErrorCode.KeycloakIntrospectionFailed
    case ErrorCode.XauthDataCookieTooLarge:
      return ErrorCode.XauthDataCookieTooLarge
    case ErrorCode.KeycloakUserinfoTimeout:
      return ErrorCode.KeycloakUserinfoTimeout
    case ErrorCode.KeycloakUserinfoHttpError:
      return ErrorCode.KeycloakUserinfoHttpError
    case ErrorCode.KeycloakUserinfoUnknownError:
      return ErrorCode.KeycloakUserinfoUnknownError
    case ErrorCode.UserinfoMissingContact:
      return ErrorCode.UserinfoMissingContact
    case ErrorCode.UserinfoMissingName:
      return ErrorCode.UserinfoMissingName
    case ErrorCode.UserinfoMissingGender:
      return ErrorCode.UserinfoMissingGender
    case ErrorCode.UserinfoInvalidGender:
      return ErrorCode.UserinfoInvalidGender
    case ErrorCode.UserinfoMissingAddress:
      return ErrorCode.UserinfoMissingAddress
    case ErrorCode.UserinfoValidation:
      return ErrorCode.UserinfoValidation
    case ErrorCode.UserinfoUnknownGroup:
      return ErrorCode.UserinfoUnknownGroup
    case ErrorCode.UserinfoUnknownRole:
      return ErrorCode.UserinfoUnknownRole
    case ErrorCode.XsrfTokenCookieMissing:
      return ErrorCode.XsrfTokenCookieMissing
    case ErrorCode.XauthDataCookieDecryptFailed:
      return ErrorCode.XauthDataCookieDecryptFailed
    case ErrorCode.XauthDataCookieDecompressFailed:
      return ErrorCode.XauthDataCookieDecompressFailed
    case ErrorCode.XauthDataCookieDeserializeFailed:
      return ErrorCode.XauthDataCookieDeserializeFailed
    case ErrorCode.XauthDataCookieUnknownError:
      return ErrorCode.XauthDataCookieUnknownError
    case ErrorCode.AccessTokenMissing:
      return ErrorCode.AccessTokenMissing
    case ErrorCode.SessionNotAuthenticated:
      return ErrorCode.SessionNotAuthenticated
    case ErrorCode.AccessTokenRefreshFailed:
      return ErrorCode.AccessTokenRefreshFailed
    default:
      return null
  }
}
